import {APIService} from "../../common/APIService";
import {AuditLog} from "../../dto/AuditLog";

export class AuditLogService extends APIService {
  public async browseByProject(projectId: string) {
    const json = await this.getJson<{data: object[]}>(`projects/${projectId}/audit_logs`)
    return json.data.map(item => AuditLog.fromJson(item))
  }

  public async browse() {
    const json = await this.getJson<{data: object[]}>(`audit-logs`)
    return json.data.map(item => AuditLog.fromJson(item))
  }
}